export default {
  write: {
    en: 'WRITE A REVIEW',
  },
  edit: {
    en: 'EDIT YOUR REVIEW',
  },
  modalText: {
    en: ' to write a review',
  },
}
